module.exports = __webpack_public_path__ + "static/media/bg_about01.5c9d3dde.png";